import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../button/Button';
import { confirmHandler } from '../toolbarUtils';
import {
    ENTER,
    SUBSTITUTE,
    INPUT_MAX_LENGTH,
    CORRECTIONS,
    INPUT_PLACEHOLDERS,
} from '../../../constants/shared/ToolbarConstants';
import './ToolbarInput.scss';
import { ICON } from '../../../constants/shared/CommonConstants';

const { DONE } = ICON;

const ToolbarInput = ({ wordPosition, inputType, setWordEvent }) => {
    const inputRef = useRef();
    const [wordValue, setWord] = useState('');
    const correctionClass = inputType === SUBSTITUTE ? 'underline' : 'insert';
    const placeholder = INPUT_PLACEHOLDERS[inputType];
    const confirmHandlerProps = { wordPosition, inputType, wordValue, setWordEvent };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const handleKeyDown = ({ keyCode }) => {
        confirmHandler({ keyCode, mouseClick: false, ...confirmHandlerProps });
    };

    return (
        <>
            <Button
                className={`corrections active ${correctionClass}`}
                text={CORRECTIONS[inputType]}
            />
            <div className="input-container">
                <div
                    tabIndex="0"
                    role="button"
                    data-test-id="rescoring-input-submit"
                    className="enter-wrapper"
                    onClick={({ keyCode }) =>
                        confirmHandler({ keyCode, mouseClick: true, ...confirmHandlerProps })
                    }
                >
                    {DONE}
                    <p className="enter-text">{ENTER}</p>
                </div>
                <input
                    ref={inputRef}
                    maxLength={INPUT_MAX_LENGTH}
                    type="text"
                    className="rescoring-input"
                    placeholder={placeholder}
                    value={wordValue}
                    onChange={({ target }) => setWord(target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>
        </>
    );
};

ToolbarInput.defaultProps = {
    wordPosition: null,
    inputType: '',
    setWordEvent: () => {},
};

ToolbarInput.propTypes = {
    wordPosition: PropTypes.number,
    inputType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    setWordEvent: PropTypes.func,
};

export default ToolbarInput;
